import * as React from 'react';

export const Container = (props) => (
    <div className={props.animation} style={props.tight? style.tight: style.loose}>
        {props.children}
    </div>
)

const style = {
    loose: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        marginTop: 50,
        flexWrap: 'wrap'
    },
    tight: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        marginTop: 50,
        flexWrap: 'wrap'
    }
}


// WEBPACK FOOTER //
// ./src/components/marketing/components/Container.js